import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../../../router/router";

const ContactUs = ({
  openContactUs,
  subMenuWidth,
  closeAllManu,
  height,
  setShowContactForm,
}) => {
  const navigate = useNavigate();
  return (
    <div
      onMouseEnter={() => openContactUs()}
      onMouseLeave={() => closeAllManu()}
      className={`absolute z-[10001]`}
      style={{ left: `${subMenuWidth.offsetLeft - 305}px` }}
    >
      <div
        className="mr-[33px]"
        style={{
          top: `${height}px`,
          width: `${subMenuWidth.offsetWidth + 305}px`,
        }}
      >
        <div className="bg-[#F2F2F2]">
          <div className="grid grid-cols-4 gap-4">
            {/* Left Sidebar Tab */}
            <div className="col-span-1 border-r-[1px] border-r-[#292929]">
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div className="border-l-[#7ABF5B] font-bold text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]">
                  CONTACT US
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-span-3 mx-[47px]">
              <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                CONTACT US
              </div>
              <div className="flex mt-[41px]">
                {/* Left Side */}
                <div className="flex-grow border-r-[1px] border-r-[#292929]">
                  <div
                    className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate("#");
                      closeAllManu();
                    }}
                  >
                    Frequently Asked Questions
                  </div>
                  <div
                    className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      navigate("#");
                      closeAllManu();
                    }}
                  >
                    Contact Tuatara
                  </div>
                </div>

                {/* Right Side */}
                <div className="w-[350px] px-[40px]">
                  <div>
                    <div className="font-bold text-[20px] font-[Roboto] text-[#000]">
                      Let's Connect!
                    </div>
                    <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                      Got questions? Find out how to connect with Tuatara.
                    </div>
                  </div>
                  <div className="mt-[21px] mb-[38px]">
                    <button
                      className="w-full border-[4px] border-[#7abf5b] text-[#fff] bg-[#7abf5b] font-[Roboto] text-[20px] py-[10px] font-bold my-[10px]"
                      style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      onClick={() => setShowContactForm(true)}
                    >
                      CONTACT TUATARA
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
